module.exports = __webpack_public_path__ + "static/img/3.54d33e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/3.png
// module id = guT1
// module chunks = 0